import { render, staticRenderFns } from "./selections.vue?vue&type=template&id=72da70ef&scoped=true"
import script from "./selections.vue?vue&type=script&lang=js"
export * from "./selections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da70ef",
  null
  
)

export default component.exports